/* Diamond Studio — store rating badges (2026-09-29)
   Shows the live Judge.me store rating (e.g. "★★★★★ 5.0 · 38 store reviews") in:
   1. the top bar on every page (desktop: next to the tagline; phones: alternates
      with the promo a few times, pauses on interaction, off for reduced motion)
   2. product pages, right under the price (moves with the price on phones)
   3. product pages, in the sticky price / buy bar
   4. collection pages, above the trust bar
   Every badge opens a reviews panel built from the <template> in ds-store-rating.liquid. */
(function () {
  'use strict';
  if (window.__dsStoreRating) return;
  window.__dsStoreRating = true;

  var dataEl = document.getElementById('ds-store-rating-data');
  if (!dataEl) return;
  var data;
  try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var count = Number(data && data.count) || 0;
  var rating = Number(data && data.rating) || 0;
  if (count < 1 || rating <= 0) return;

  var ratingText = rating.toFixed(1);
  var reviewsWord = count === 1 ? 'review' : 'reviews';
  var ariaLabel = 'Rated ' + ratingText + ' out of 5 from ' + count + ' store ' + reviewsWord + '. Read the reviews';

  function stars(extraClass) {
    var s = document.createElement('span');
    s.className = 'ds-sr-stars' + (extraClass ? ' ' + extraClass : '');
    s.style.setProperty('--ds-sr', String(rating));
    s.setAttribute('aria-hidden', 'true');
    return s;
  }

  function badge(variant, label) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'ds-sr-badge ds-sr-badge--' + variant;
    b.setAttribute('data-ds-sr-open', '');
    b.setAttribute('aria-haspopup', 'dialog');
    b.setAttribute('aria-label', ariaLabel);
    b.appendChild(stars());
    var t = document.createElement('span');
    t.className = 'ds-sr-badge__text';
    t.innerHTML = label;
    b.appendChild(t);
    return b;
  }

  var LABELS = {
    pdp: '<strong>' + ratingText + '</strong> &middot; ' + count + ' store ' + reviewsWord,
    sticky: '<strong>' + ratingText + '</strong> (' + count + ')',
    collection: '<strong>' + ratingText + '</strong> &middot; ' + count + ' customer ' + reviewsWord + ' <span aria-hidden="true">&rsaquo;</span>',
    bar: 'Rated <strong>' + ratingText + '</strong> by our customers &middot; ' + count + ' ' + reviewsWord,
    barShort: '<strong>' + ratingText + '</strong> &middot; ' + count + ' customer ' + reviewsWord
  };

  /* ---------- Placements (idempotent; re-run when the page re-renders) ---------- */
  function placeTopBar() {
    var bar = document.querySelector('.shop-utility.ds-gift-utility');
    if (!bar || bar.querySelector('.ds-sr-badge')) return;
    var left = bar.children[0];
    var center = bar.querySelector('.ds-gift-announcement');
    if (left) {
      // Desktop: tagline · rating. If both don't fit on one line, the tagline steps aside.
      var tagline = document.createElement('span');
      tagline.className = 'ds-sr-tagline';
      while (left.firstChild) tagline.appendChild(left.firstChild);
      left.appendChild(tagline);
      var sep = document.createElement('span');
      sep.className = 'ds-sr-sep';
      sep.setAttribute('aria-hidden', 'true');
      sep.textContent = '·';
      left.appendChild(sep);
      left.appendChild(badge('bar', LABELS.barShort));
      fitTopBar(left);
      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () { fitTopBar(left); }, 150);
      });
    }
    if (center) {
      var rot = badge('bar', LABELS.bar);
      rot.classList.add('ds-sr-badge--rotate');
      center.classList.add('ds-sr-rotator');
      center.appendChild(rot);
      startRotation(bar, left, center);
    }
  }

  function fitTopBar(left) {
    if (!left || getComputedStyle(left).display === 'none') return;
    left.classList.remove('ds-sr-tagline-off');
    var tagline = left.querySelector('.ds-sr-tagline');
    var b = left.querySelector('.ds-sr-badge');
    if (!tagline || !b) return;
    // Wrapped onto a second line? Then show only the rating.
    if (b.getBoundingClientRect().top >= tagline.getBoundingClientRect().bottom - 1) {
      left.classList.add('ds-sr-tagline-off');
    }
  }

  function placeProduct() {
    var row = document.querySelector('#product .a-price-row') || document.querySelector('.a-price-row');
    if (row && !row.querySelector('.ds-sr-badge')) row.appendChild(badge('pdp', LABELS.pdp));
    var sticky = document.querySelector('.a-sticky-price');
    if (sticky && !sticky.querySelector('.ds-sr-badge')) sticky.appendChild(badge('sticky', LABELS.sticky));
  }

  function placeCollection() {
    var results = document.querySelector('.ds-studio-collection .dsc-results') || document.querySelector('.dsc-results');
    if (!results || results.querySelector('.ds-sr-row')) return;
    var anchor = results.querySelector('.ds-studio-confidence-desktop') || results.querySelector('.ds-studio-confidence-mobile');
    if (!anchor) return;
    var row = document.createElement('div');
    row.className = 'ds-sr-row';
    row.appendChild(badge('collection', LABELS.collection));
    anchor.parentNode.insertBefore(row, anchor);
  }

  function placeAll() {
    try { placeTopBar(); } catch (e) {}
    try { placeProduct(); } catch (e) {}
    try { placeCollection(); } catch (e) {}
  }

  /* ---------- Phone top bar: alternate promo / rating a few times ---------- */
  function startRotation(bar, left, center) {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;
    var flips = 0;
    var MAX_FLIPS = 6;      // promo -> rating -> promo ... then stays on the promo
    var paused = false;
    function leftHidden() { return !left || getComputedStyle(left).display === 'none'; }
    center.addEventListener('pointerenter', function () { paused = true; });
    center.addEventListener('pointerleave', function () { paused = false; });
    center.addEventListener('focusin', function () { paused = true; });
    center.addEventListener('focusout', function () { paused = false; });
    center.addEventListener('touchstart', function () { paused = true; }, { passive: true });
    var timer = setInterval(function () {
      if (paused || !leftHidden()) return;
      center.classList.toggle('ds-sr-show-rating');
      flips += 1;
      if (flips >= MAX_FLIPS) {
        clearInterval(timer);
        center.classList.remove('ds-sr-show-rating');
      }
    }, 4500);
  }

  /* ---------- Reviews panel ---------- */
  var dialog = null;
  var lastTrigger = null;

  function buildDialog() {
    var tpl = document.getElementById('ds-store-rating-panel');
    if (!tpl || !tpl.content) return null;
    var d = document.createElement('dialog');
    d.className = 'ds-sr-dialog';
    d.setAttribute('aria-labelledby', 'ds-sr-title');
    d.appendChild(tpl.content.cloneNode(true));
    d.addEventListener('click', function (event) {
      if (event.target === d) d.close();                       // backdrop
      if (event.target.closest && event.target.closest('[data-ds-sr-close]')) d.close();
    });
    d.addEventListener('close', function () {
      document.documentElement.classList.remove('ds-sr-open');
      if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
    });
    document.body.appendChild(d);
    return d;
  }

  function openPanel(trigger) {
    if (!dialog) dialog = buildDialog();
    if (!dialog) {
      // No panel available: fall back to the reviews already on product pages.
      var stories = document.querySelector('.dsj-stories');
      if (stories) stories.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    lastTrigger = trigger;
    document.documentElement.classList.add('ds-sr-open');
    if (dialog.showModal) dialog.showModal(); else dialog.setAttribute('open', '');
    var list = dialog.querySelector('.ds-sr-list');
    if (list) list.scrollTop = 0;
    try {
      if (window.dataLayer) window.dataLayer.push({ event: 'ds_store_reviews_open', placement: trigger && trigger.className });
    } catch (e) {}
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target && event.target.closest ? event.target.closest('[data-ds-sr-open]') : null;
    if (!trigger) return;
    event.preventDefault();
    event.stopPropagation();
    openPanel(trigger);
  }, true);

  /* ---------- Start, and keep badges in place when the theme re-renders ---------- */
  var queued = false;
  function queuePlace() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; placeAll(); });
  }

  function init() {
    placeAll();
    new MutationObserver(queuePlace).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
